export default __webpack_public_path__ + "static/SLR_Pressemeldung_1_1_de-f832181e6aaca87e342f545ff1462bf1.jpg";